import { listDashboardClinics, type DashboardClinicOption } from './api';

export async function getDashboardClinics(options?: {
  signal?: AbortSignal;
}): Promise<DashboardClinicOption[]> {
  const { data } = await listDashboardClinics({
    signal: options?.signal,
    throwOnError: true,
  });
  return data;
}
